import { DatePipe, NgForOf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { singleOrderDetails } from '../../../../@store/orders/orders.model';

@Component({
  selector: 'ciwc-order-change-history',
  imports: [NgForOf, DatePipe],
  standalone: true,
  templateUrl: './order-change-history.component.html',
  styleUrl: './order-change-history.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderChangeHistoryComponent {
  @Input() orderDetails!: singleOrderDetails | null;

  trackByLogId(_index: number, log: { id: number }): number {
    return log.id;
  }
}
